import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { getPath } from '../config/routeMap';

/**
 * <LocLink to="products"> — a Link that resolves a route KEY to the
 * correct localized URL based on the active language.
 *
 * Usage:
 *   <LocLink to="home">Home</LocLink>
 *   <LocLink to="projectAct">Project ACT</LocLink>
 *   <LocLink to="projectAct" hash="#external-adrenal-resources">…</LocLink>
 *
 * Any other `<Link>` prop (className, onClick, data-testid, replace…) is
 * passed through.
 */
const LocLink = React.forwardRef(function LocLink({ to, hash, ...rest }, ref) {
  const { language } = useLanguage();
  const base = getPath(to, language);
  const target = hash ? `${base}${hash}` : base;
  return <Link ref={ref} to={target} {...rest} />;
});

export default LocLink;
